import { render, staticRenderFns } from "./DropdownSeparator.vue?vue&type=template&id=3ec1eba2"
import script from "./DropdownSeparator.vue?vue&type=script&lang=js"
export * from "./DropdownSeparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports